import React from 'react';
import PageLayout from '../components/Layout';
import colors from '../styles/colors';

const PageContent = className => {
  return (
    <div style={{ padding: 35 + 'px', background: colors.lightGray }} className='page'>
      <h1 style={{ textAlign: 'center' }}>Something Broke</h1>
      <h3 style={{ textAlign: 'center' }}>
        The page you are looking for does not exist
      </h3>
      <h3 style={{ textAlign: 'center' }}>
        Please double check your URL to make sure it is correct.
      </h3>
      <h3 style={{ textAlign: 'center' }}>
        Or press the back button on your browser to go back.
      </h3>
    </div>
  );
};

const NotFoundPage = () => (
  <PageLayout>
    <PageContent />
  </PageLayout>
);

export default NotFoundPage;
